module.exports = __webpack_public_path__ + "static/mountain-right-cfacdd59ee74f31375140b517c9c2b4f.png";